import React from "react"

import { Container, Typography } from "src/UILibrary"
import { useMediaQuery } from "react-responsive"
import "src/styles/common.scss"

export const Title = ({ title, sub_title }: { title: string; sub_title: string }) => {
  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  return (
    <Container maxWidth="lg" className="title">
      {isTablet ? (
        <>
          <Typography.Larger color="textPrimary">{title}</Typography.Larger>
          <Typography.Large color="textPrimary" sx={{ mt: "20px" }}>
            {sub_title}
          </Typography.Large>
        </>
      ) : (
        <>
          <Typography.Large color="textPrimary">{title}</Typography.Large>
          <Typography.Large color="textPrimary" sx={{ mt: "10px", fontSize: "18px" }}>
            {sub_title}
          </Typography.Large>
        </>
      )}
    </Container>
  )
}
